<template lang="pug">
  #app
    template(v-if="loaded")
      router-view
      server-alert
</template>

<script>
import ServerAlert from '@/components/common/server-alert/ServerAlert'

export default {
  name: 'app',

  components: {
    ServerAlert
  },

  data: () => ({
    loaded: false
  }),

  async mounted () {
    const { isAuth } = await this.$store.dispatch('account/init')
    if (isAuth) {
      if (!this.$route.path.includes('app') || this.$route.path === '/app') {
        if (this.isClient) {
          this.$router.push('/app/companies')
        } else {
          if (!this.$route.params.client_id) {
            this.$router.push('/app/clients')
          }
        }
      }
    } else {
      this.$router.push('/auth')
    }
    this.loaded = true
  }
}
</script>

<style lang="scss">
  @import '@/sass/main.scss';
</style>
